import { AfterViewInit, Component, forwardRef, Input, OnChanges, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { InputBaseReactComponent } from '../input-base-react/input-base-react.component';
import { InputDateTimeReactMode } from './input-datetime-react.enum';

// Range datepicker Start
const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
  one && two && two.year === one.year && two.month === one.month && two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day < two.day : one.month < two.month : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day > two.day : one.month > two.month : one.year > two.year;
// Range datepicker Ends

@Component({
  selector: 'app-input-datetime-react',
  templateUrl: './input-datetime-react.component.html',
  styleUrls: ['./input-datetime-react.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDateTimeReactComponent),
      multi: true
    }
  ]
})

export class InputDateTimeReactComponent extends InputBaseReactComponent implements ControlValueAccessor, OnInit, OnChanges, AfterViewInit {

  placeholderMask: string;
  maskFormat: string;
  fromDate: NgbDateStruct;
  toDate: NgbDateStruct;

  @Input() filterMode?: InputDateTimeReactMode = InputDateTimeReactMode.idrmDate;

  @Input() spanInvalidDate: string;

  private dateValue: Date;
  private inputMask: string;
  private validateMask: string;
  private validDate: boolean;
  private nullDate: boolean;
  public dateFormatType = InputDateTimeReactMode;

  protected onChange: any = () => {
    const dataMoment = moment(this.value, this.validateMask, true);
    this.validDate = dataMoment.isValid();
    this.dateValue = dataMoment.toDate();
  };

  //#region .  LifeCycle Methods e Construtor
  constructor() {
    super();
  }

  //#region .  Métodos  .

  // chama método ngOnInit da classe base e prepara valores de spans de validação
  ngOnInit(): void {
    super.ngOnInit();

    if (this.filterMode) {
      switch (this.filterMode) {
        case InputDateTimeReactMode.idrmDate:
          this.placeholderMask = 'dd/mm/aaaa';
          this.inputMask = 'DD/MM/YYYY';
          this.validateMask = 'DD/MM/YYYY';
          break;
        case InputDateTimeReactMode.idrmTime:
          this.placeholderMask = 'hh:mm:ss';
          this.inputMask = 'HH:mm:ss';
          this.validateMask = 'HH:mm:ss';
          this.maskFormat = '99:99:99';
          break;
        case InputDateTimeReactMode.idrmDateTime:
          this.placeholderMask = 'dd/mm/aaaa hh:mm:ss';
          this.inputMask = 'DD/MM/YYYY HH:mm:ss';
          this.validateMask = 'DD/MM/YYYY HH:mm:ss';
          break;
        default:
          break;
      }
    }

    if (!this.spanInvalidDate) {
      this.spanInvalidDate = 'Data Inválida';
    }

    this.loadValidators();
    this.setAndUpdateValidators();
  }

  ngAfterViewInit(): void {
    let valorMudar: any;
    let dataMoment: moment.Moment;

    valorMudar = this.detailMode ? this.value : this.field.nativeElement.value;

    dataMoment = moment(valorMudar, this.validateMask, true);

    this.validDate = true;
    if (!dataMoment.isValid()) { this.validDate = false; }
    if (this.validDate) {
      this.dateValue = dataMoment.toDate();
    }
  }

  // chama método ngOnChanges da classe base e efetua o recarregamento de validadores.
  // tslint:disable-next-line:use-life-cycle-interface
  ngOnChanges(): void {
    super.ngOnChanges();
    this.loadValidators();
    this.setAndUpdateValidators();
  }



  // Range datepicker starts
  onDateChange(date: NgbDateStruct) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && after(date, this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }

    this.changeValue(date.day + '/' + date.month + '/' + date.year);
  }

  //#endregion
  formatDateDetailMode(): string {
    if (this.nullDate) {
      return '-------------------';
    } else
      if (this.filterMode) {
        return moment(this.dateValue)
          .format(this.inputMask);
      }
  }

  changeValue(event): void {
    const dataMoment = moment(this.field.nativeElement.value, this.validateMask, true);
    this.validDate = true;
    if (dataMoment === undefined || !dataMoment.isValid()) { this.validDate = false; }
    if (this.validDate) {
      this.dateValue = dataMoment.toDate();
      this.writeValue(dataMoment.toDate());
    } else {
      if (this.field.nativeElement.value === '') {
        this.validDate = true;
      }
      const valorNovo = this.field.nativeElement.value;
      this.writeValue(valorNovo);
    }
  }



  writeValue(obj: any): void {
    let valorStr: string;
    if (obj instanceof Date) {
      valorStr = moment(obj)
        .format(this.inputMask);
      this.nullDate = false;
      this.value = valorStr;
      this.onChange(obj);
    } else {
      this.nullDate = true;
      this.value = obj;
      this.onChange(obj);
    }
  }

  validateValidDate(): boolean {
    return this.control.hasError('validateDate');
  }



  protected validateDate(c: FormControl): any {
    if (!this.required) {
      return true;
    }

    let validDateda: boolean;
    validDateda = this.nullDate ? true : validDateda = this.validDate;

    return validDateda ? undefined : { validateDate: { valid: false } };
  }

  private loadValidators(): void {
    this.insertValidator(this.validateDate.bind(this));
  }
}
